export function filterAndSortVinos(vinos, q, sortBy) {
    const term = String(q || "").trim().toLowerCase();
    const arr = Array.isArray(vinos) ? [...vinos] : [];

    const filtered = arr.filter((v) => {
        if (!term) return true;
        return [v?.nombre, v?.descripcion, v?.tipo]
            .filter(Boolean)
            .map((x) => String(x).toLowerCase())
            .some((txt) => txt.includes(term));
    });

    if (sortBy === "tipo") {
        filtered.sort((a, b) => String(a?.tipo || "").localeCompare(String(b?.tipo || ""), "es"));
        return filtered;
    }

    filtered.sort((a, b) => String(a?.nombre || "").localeCompare(String(b?.nombre || ""), "es"));
    return filtered;
}
